import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { AccountServices } from "../api";

/**
 * Hook for user Informations after signup
 */
const onDefaultError = (error) => {
  toast.error(error.message);
};
const useGetProfile = (onSuccess, onError = onDefaultError) => {
  return useQuery("get-profile", AccountServices.viewProfile, {
    onSuccess,
    onError,
  });
};

const useUpdateProfile = (onSuccess, onError = onDefaultError) => {
  return useMutation(AccountServices.updateProfile, {
    onSuccess,
    onError,
  });
};

export { useGetProfile, useUpdateProfile };
